// Components/Common/ProtectedRoute.js
import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';

const ProtectedRoute = ({ children }) => {
    const { authState, isPending } = useOktaAuth();
    const location = useLocation();

    // Show loading indicator while auth state is being determined
    if (isPending || authState === null) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '50vh',
                    color: 'var(--text-primary)'
                }}
            >
                <CircularProgress size={40} sx={{ marginBottom: 2 }} />
                <Typography variant="h6">Verifying authentication...</Typography>
            </Box>
        );
    }

    // If not authenticated, redirect to login page
    if (!authState.isAuthenticated) {
        // Store the location they were trying to access for redirect after login
        return (
            <Navigate
                to="/login"
                state={{ from: location.pathname }}
                replace
            />
        );
    }

    // If authenticated, render the protected component
    return children;
};

export default ProtectedRoute;